export const getEditPersonLink = ({ customerId, sport, organizationId, personId }) =>
  `/${customerId}/admin/${sport}/${organizationId}/persons/manage/${personId}`;
